import React from 'react';
import Spinner from '@shared/spinner/spinner.container';
import ReCAPTCHA from 'react-google-recaptcha';
import ContactReason from './contact-reason/contact-reason.container';
import ShowForm from './show-form/show-form';
import ContactFields from './contact-fields/contact-fields.container';
import { FieldData, FormFieldsData, FormType } from '../../types/form.types';
import ContactFormComponents from './contact-form.components';
import SmartFaq from '../smart-faq/smart-faq';

interface ContactFormContentProps {
  isReasonFilled: boolean;
  isFormVisible: boolean;
  isErrorVisible: boolean;
  reasons: FieldData[];
  showFormHandler: () => void;
  formFields: FormFieldsData;
  isLoading: boolean;
  errorMessage?: string;
  type: FormType;
}
const { TopLine, FetchErrorMessage } = ContactFormComponents;
const ContactFormContent: React.ForwardRefRenderFunction<
  ReCAPTCHA,
  ContactFormContentProps
> = (
  {
    isReasonFilled,
    reasons,
    showFormHandler,
    isFormVisible,
    isErrorVisible,
    formFields,
    isLoading,
    errorMessage,
    type
  },
  recaptchaRef
) => {
  return (
    <>
      {reasons[0] && (
        <TopLine>
          <ContactReason reasons={reasons} />
          <SmartFaq />
        </TopLine>
      )}
      {isReasonFilled && !isFormVisible && reasons[0] && (
        <ShowForm showForm={showFormHandler} />
      )}
      {(isFormVisible || !reasons[0]) && (
        <ContactFields fields={formFields} type={type} ref={recaptchaRef} />
      )}
      <Spinner isActive={isLoading} />
      {isErrorVisible && <FetchErrorMessage>{errorMessage}</FetchErrorMessage>}
    </>
  );
};
export default React.forwardRef(ContactFormContent);
